// extracted by mini-css-extract-plugin
module.exports = {"ie11Hack":"kOc8C"};